<template>
    <div :class="{conditions:!$store.state.isMobile,mconditions:$store.state.isMobile,}">
        <main>
            <div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{ 'infos' }}
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>{{ chooseRouterData.headerName }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="container">
                <div class="left">
                    <p v-for="(item, index) in routerlist" :key="index">
                        <router-link
                            :class="item.path==$route.path || routeTest === index || $route.path=='/Moncompte/Articles'&&index==5 ?'border':''"
                            :to="item.path" @click.native="onMenuItemClick(item)"
                            replace
                        >{{ item.name[0] }}
                        </router-link>
                    </p>
                </div>
                <div class="right">
                    <!-- <p class="title">{{$route.name}}</p> -->
                    <router-view></router-view>
                </div>
            </div>

        </main>
    </div>
</template>
<script>
export default {
    name: "Conditions",
    data() {
        return {
            langPage: this.$store.state.langPage,
            urlType: this.$route.query.type,
            chooseRouterData: {},
            routerlist: [
                {
                    name: ["CGUV"],
                    path: "/conditions/commonPage?type=cguv",
                    type: 'cguv',
                    headerName: this.$langPage['pages-cguv']['TXT_seotitleheader']
                },
                {
                    name: ["CONTACT"],
                    path: "/conditions/contact",
                    type: 'contact',
                    headerName: this.$langPage['pages-menu']['TXT_contact']
                },
                {
                    name: ["MENTIONS LÉGALES"],
                    path: "/conditions/commonPage?type=mentionslegales",
                    type: 'mentionslegales',
                    headerName: this.$langPage['pages-mentionslegales']['TXT_seotitleheader']
                },
                {
                    name: ["POLITIQUES DE CONFIDENTIALITÉ"],
                    path: "/conditions/commonPage?type=pdc",
                    type: 'pdc',
                    headerName: this.$langPage['pages-pdc']['TXT_seotitleheader']
                },
                {
                    name: ["POLITIQUE DE COOKIES"],
                    path: "/conditions/commonPage?type=rgpd",
                    type: 'rgpd',
                    headerName: this.$langPage['pages-rgpd']['TXT_seotitleheader']
                }
            ]
        };
    },
    computed: {
        routeTest() {
            let state = null
            this.routerlist.forEach((item, index) => {
                item.name.forEach((data) => {
                    if (data == this.$route.name) state = index
                    else state = null
                })
            })
            return state
        }
    },
    mounted() {
        let path = this.$route.path;
        path = path.substring(path.lastIndexOf('/') + 1);
        if (path === 'conditions') window.location.href = this.routerlist[0].path;
        this.getChooseRouterData();
    },
    methods: {
        async onMenuItemClick(item) {
            if (item.name[0] === this.$t("account.word1")) {
                localStorage.clear();
                this.$store.commit('set', {key: 'token', value: ''});
                window.document.cookie = '';
                this.$router.push({path: '/'})
            }
        },
        getChooseRouterData() {
            let urlType = this.urlType;
            if (!urlType) urlType = 'contact';
            this.chooseRouterData = this.routerlist.find(item => {
                return item.type == urlType;
            })
            console.log('chooseRouter', this.chooseRouterData)
        }
    }
};
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Conditions.less">
</style>
<style lang="less">
.conditions {
    .SubTitle {
        font-size: 0.32rem;
        font-family: Ogg-Roman;
        line-height: 0.48rem;
        padding-bottom: 0.21rem;
    }
}

.mconditions {
    .SubTitle {
        font-size: 16pt;
        font-family: Ogg-Roman;
        line-height: 0.48rem;
        padding-bottom: 0.21rem;
    }
}
</style>
